var React = require('react');

function BannerArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.4299 5.93018L27.4999 12.0002L21.4299 18.0702","stroke":"#D52430","strokeWidth":"1.8","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 12L27 12","stroke":"#D52430","strokeWidth":"1.8","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BannerArrowRight.defaultProps = {"width":"31","height":"24","viewBox":"0 0 31 24","fill":"none"};

module.exports = BannerArrowRight;

BannerArrowRight.default = BannerArrowRight;
